import axios from "axios";
// Stub: Accessor mirrors solid-js – update import once solid-js dependency is added or types are migrated to React.
// import { Accessor } from "solid-js";
type Accessor<T> = () => T;

import { PS_LOGGED_IN_URL, PS_NON_LOGGER_IN_URL } from "../types/insight-search-constants.types";
// Stub: response types mirror InsightSearchTypesV2 – update import once component types are migrated.
// import {
//   IAutoSuggAPIResponse,
//   IPopularSearchAPIResponse,
//   IPopularSearchAPISuccess,
//   IPreTypingAPIResponse,
// } from "../../components/xaop/solid/InsightSearchV2/InsightSearchTypesV2";
import { API_Domain } from "../constants/api-paths";
import { getCookie } from "@repo/shared-utils/common-utils";
import { IResponse, encryptedRequest, request } from "../core/api.client";
// getCSRF is a synchronous helper – remove await if not needed
const getCSRF = () => getCookie("CSRFtoken");

type IAutoSuggAPIResponse = IResponse<unknown>;
type IPopularSearchAPIResponse = IResponse<unknown>;
type IPopularSearchAPISuccess = [string, IPopularSearchAPIResponse];
type IPreTypingAPIResponse = IResponse<unknown>;

export const fetchPopularSearch = async (
  isLoggedIn: boolean,
  reqBody: { mobileNo?: string; custType?: string; appVersion?: string } | null
): Promise<IPopularSearchAPISuccess> => {
  try {
    let response: IPopularSearchAPIResponse;
    if (isLoggedIn) {
      response = await encryptedRequest({
        method: "POST",
        url: PS_LOGGED_IN_URL,
        data: reqBody,
      });
    } else {
      response = await request({
        method: "GET",
        url: PS_NON_LOGGER_IN_URL,
      });
    }
    return ["success", response];
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchPreTypingApiResponse = async (
  inputData: Accessor<string>,
  mobile_No: string,
  csrfToken?: string
): Promise<IPreTypingAPIResponse> => {
  let token = csrfToken || getCookie("CSRFtoken");
  if (!token) {
    token = getCSRF();
  }
  try {
    const { data } = await axios({
      method: "POST",
      url: `${API_Domain}/api/v5/autocomplete`,
      data: {
        query: inputData() || " ",
        _csrf: token,
        mobile_No: mobile_No,
      },
      withCredentials: true,
    });
    if (data?.data) {
      return data.data as IPreTypingAPIResponse;
    }
    return data as IPreTypingAPIResponse;
  } catch (err) {
    // biome-ignore lint/suspicious/noExplicitAny : Does not have a specified type
    if ((err as any).response.status === 403) {
      //  Retry logic to generate CSRF
      const csrfToken = getCSRF();
      return fetchPreTypingApiResponse(inputData, mobile_No, csrfToken);
    }
    throw err;
  }
};

export const fetchAutocompleteApiResponse = async (
  inputData: Accessor<string>,
  csrfToken = ""
): Promise<IAutoSuggAPIResponse> => {
  let token = csrfToken || getCookie("CSRFtoken");
  if (!token) {
    token = getCSRF();
  }

  try {
    const { data } = await axios({
      method: "POST",
      url: `${API_Domain}/api/v5/autocomplete`,
      data: {
        query: inputData(),
        _csrf: token,
      },
      withCredentials: true,
    });
    if (data.data) {
      return data as IAutoSuggAPIResponse;
    }
    return data as IAutoSuggAPIResponse;
  } catch (err) {
    // biome-ignore lint/suspicious/noExplicitAny : Does not have a specified type
    if ((err as any).response.status === 403) {
      //  Retry logic to generate CSRF
      const csrfToken = getCSRF();
      return fetchAutocompleteApiResponse(inputData, csrfToken);
    }
    throw err;
  }
};
